import { Link, Typography } from "@mui/material";

export const Contact = () => {
	return (
		<>
			<Typography variant="h6">
				Contact me by{" "}
				<Link href="mailto:infernious@live.com">email</Link>.
			</Typography>
		</>
	);
};
